import { useParams, Link } from 'react-router-dom';
import { usePost } from '../hooks';
import { BlogPost } from '../components';
import './SinglePostPage.css';

export function SinglePostPage() {
  const { id } = useParams();
  const { post, loading, error } = usePost(id);

  if (loading) {
    return (
      <div className="single-post-page__loading">
        <div className="spinner"></div>
      </div>
    );
  }

  if (error || !post) {
    return (
      <div className="single-post-page__error">
        <p className="text-muted">{error || 'Post not found'}</p>
        <Link to="/" className="text-sans">
          Back to home
        </Link>
      </div>
    );
  }

  return (
    <div className="single-post-page">
      <Link to="/" className="single-post-page__back text-sans text-small">
        &larr; Back
      </Link>
      <BlogPost post={post} isPreview={false} />
    </div>
  );
}
